export { default } from './DidNotFindResourceItem';



// WEBPACK FOOTER //
// ./app/components/search/DidNotFindResourceItem/index.js